import React from 'react'
import styled from 'styled-components'

import CreditCardLogo from '../../../../CreditCardLogo'
import { CustomerOrderPageData } from './types'

const StyledAddress = styled.address`
  font-style: inherit;
`

export const StyledParagraphText = styled.div`
  line-height: 125%;
  &:not(:last-of-type) {
    padding-bottom: 16px;
  }
  @media (min-width: 600px) {
    flex: 1;
    margin-bottom: 0;
  }
  strong {
    text-transform: uppercase;
  }
`

export const StyledHeading = styled.div`
  margin-bottom: 16px;
`

export interface ShippingAndPaymentProps {
  className?: string
  order: CustomerOrderPageData
}

const ShippingAndPayment: React.FC<ShippingAndPaymentProps> = ({ className, order }) => {
  return (
    <div className={className}>
      {order.shippingAddress && (
        <StyledParagraphText>
          <StyledHeading>Shipped to:</StyledHeading>
          <StyledAddress>
            <strong>{order.shippingAddress.addressee}</strong>
            <div>
              {order.shippingAddress.street.map((streetData) => (
                <span key={streetData}> {streetData}</span>
              ))}
            </div>
            <div>
              {order.shippingAddress.city}, {order.shippingAddress.state}{' '}
              {order.shippingAddress.countryCode} {order.shippingAddress.zip}
            </div>
          </StyledAddress>
          <div>{order.shippingAddress.phone}</div>
        </StyledParagraphText>
      )}
      {order.payment && (
        <StyledParagraphText>
          <StyledHeading>Payment method:</StyledHeading>
          {order.payment.creditCard ? (
            <>
              <CreditCardLogo ccType={order.payment.creditCard.ccType} />
              <div>xxxx xxxx xxxx {order.payment.creditCard.ccLast4}</div>
              <div>Exp. {order.payment.creditCard.ccExpDate}</div>
            </>
          ) : (
            order.payment.terms
          )}
        </StyledParagraphText>
      )}
    </div>
  )
}

const StyledShippingAndPayment = styled(ShippingAndPayment)({
  '@media(min-width: 600px)': {
    display: 'flex',
    flexWrap: 'nowrap',
  },
})

export { StyledShippingAndPayment as ShippingAndPayment }
